import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Layout from './components/Layout';

// Dashboard & Core
import Dashboard from './pages/Dashboard';

// Phase 1: CRM
import ThirdParties from './pages/ThirdParties';
import Contacts from './pages/Contacts';

// Phase 2: Sales
import Proposals from './pages/Proposals';
import Orders from './pages/Orders';
import SalesRecords from './pages/SalesRecords';

// Phase 3: Purchases
import PurchaseOrders from './pages/PurchaseOrders';
import PurchaseRecords from './pages/PurchaseRecords';

// Phase 4: Products & MRP
import ProductCatalog from './pages/ProductCatalog';
import Stock from './pages/Stock';
import MRP from './pages/MRP';

// Phase 5: Financial, Bank & Accounting
import BankAccounts from './pages/BankAccounts';
import BankTransactions from './pages/BankTransactions';
import ChartOfAccounts from './pages/ChartOfAccounts';
import AccountingJournals from './pages/AccountingJournals';

// Phase 6: Human Resources (HRM)
import Employees from './pages/Employees';
import ExpenseReports from './pages/ExpenseReports';
import Salaries from './pages/Salaries';
import LeaveList from './pages/LeaveList';
import Presences from './pages/Presences';

// Phase 7: Projects & Documents
import Projects from './pages/Projects';
import Tasks from './pages/Tasks';
import Documents from './pages/Documents';

// Phase 8: POS, Tools & Settings
import POS from './pages/POS';
import Tools from './pages/Tools';
import MoceanAPI from './pages/MoceanAPI';
import Settings from './pages/Settings';

// Existing Pages
import SupplierInvoice from './pages/SupplierInvoice';
import CustomerInvoice from './pages/CustomerInvoice';
import SupplierPayment from './pages/SupplierPayment';
import CustomerPayment from './pages/CustomerPayment';
import InvoiceBinding from './pages/InvoiceBinding';
import MiscPayments from './pages/MiscPayments';
import GenericAccountingPage from './pages/GenericAccountingPage';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          
          {/* Phase 1: CRM */}
          <Route path="/crm/third-parties" element={<ThirdParties />} />
          <Route path="/crm/contacts" element={<Contacts />} />

          {/* Phase 2: Sales */}
          <Route path="/sales/proposals" element={<Proposals />} />
          <Route path="/sales/orders" element={<Orders />} />
          <Route path="/sales/records" element={<SalesRecords />} />

          {/* Phase 3: Purchases */}
          <Route path="/purchase/orders" element={<PurchaseOrders />} />
          <Route path="/purchase/records" element={<PurchaseRecords />} />

          {/* Phase 4: Products & MRP */}
          <Route path="/products/catalog" element={<ProductCatalog />} />
          <Route path="/products/stock" element={<Stock />} />
          <Route path="/mrp" element={<MRP />} />

          {/* Phase 5: Financial, Bank & Accounting */}
          <Route path="/bank/accounts" element={<BankAccounts />} />
          <Route path="/bank/transactions" element={<BankTransactions />} />
          <Route path="/accounting/chart-of-accounts" element={<ChartOfAccounts />} />
          <Route path="/accounting/journals" element={<AccountingJournals />} />

          {/* Phase 6: Human Resources (HRM) */}
          <Route path="/hrm/employees" element={<Employees />} />
          <Route path="/hrm/expenses" element={<ExpenseReports />} />
          <Route path="/hrm/salaries" element={<Salaries />} />
          <Route path="/hrm/leaves" element={<LeaveList />} />
          <Route path="/hrm/presences" element={<Presences />} />

          {/* Phase 7: Projects & Documents */}
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/tasks" element={<Tasks />} />
          <Route path="/documents" element={<Documents />} />

          {/* Phase 8: POS, Tools & Settings */}
          <Route path="/pos" element={<POS />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/moceanapi" element={<MoceanAPI />} />
          <Route path="/settings" element={<Settings />} />

          {/* Dynamic Invoice Pages */}
          <Route path="/invoice/supplier/:id" element={<SupplierInvoice />} />
          <Route path="/invoice/customer" element={<CustomerInvoice />} />
          
          <Route path="/invoice/pay-supplier" element={<SupplierPayment />} />
          <Route path="/invoice/pay-customer" element={<CustomerPayment />} />
          
          <Route path="/accounting/misc-payments" element={<MiscPayments />} />
          <Route path="/accounting/bind" element={<InvoiceBinding />} />

          {/* Generic Accounting Routes */}
          <Route path="/accounting/binding-1" element={<GenericAccountingPage title="Binding" />} />
          <Route path="/accounting/general" element={<GenericAccountingPage title="Accounting" />} />
          <Route path="/accounting/income" element={<GenericAccountingPage title="Income" />} />
          <Route path="/accounting/sales-cos" element={<GenericAccountingPage title="Sales - COS" />} />
          <Route path="/accounting/product-income" element={<GenericAccountingPage title="Product Income" />} />
          <Route path="/accounting/general-2" element={<GenericAccountingPage title="General" />} />
          <Route path="/accounting/accounting-income" element={<GenericAccountingPage title="Accounting income" />} />
          <Route path="/accounting/comprehensive-income" element={<GenericAccountingPage title="Comprehensive income" />} />
          <Route path="/accounting/total-assets" element={<GenericAccountingPage title="Total of assets" />} />
          <Route path="/accounting/sale-2" element={<GenericAccountingPage title="Sale" />} />
          <Route path="/accounting/income-2" element={<GenericAccountingPage title="Income" />} />
          <Route path="/accounting/base-income" element={<GenericAccountingPage title="Base Income" />} />

        </Route>
      </Routes>
    </HashRouter>
  );
}

export default App;